import s from "./news.module.css";
import Breadcrumbs from "../../assets/Components/breadcrumbs/breadcrumbs";
import n1 from "../../img/news/main/n1.jpg";
import n2 from "../../img/news/main/n2.jpg";
import n3 from "../../img/news/main/n3.jpg";
import NewsItem from "./NewsItem";
import useDocumentTitle from "../../assets/Tools/DocumentTitle/DocumentTitle";


const News = () => {

    useDocumentTitle('Новости');

    return (
        <div className={s.news}>
            <div className={`${s.newsContent} content`}>
                <Breadcrumbs/>
                <h3>Новости</h3>
                <NewsItem title="Как лучше стирать нашу продукцию?" day="01.01.2021"
                          post="Повседневная практика показывает, что новая модель организационной деятельности
                          требуют определения и уточнения системы обучения кадров, соответствует насущным потребностям.
                           Не следует, однако забывать, что начало повседневной работы по формированию позиции требуют
                           от нас анализа новых предложений.
                          Товарищи! укрепление и развитие структуры требуют определения и уточнения модели развития."
                          img={n1}
                />
                <NewsItem title="Материалы, что мы используем" day="09.09.2020"
                          post="Задача организации, в особенности же постоянное информационно-пропагандистское
                          обеспечение нашей деятельности обеспечивает широкому кругу (специалистов)
                           участие в формировании позиций, занимаемых участниками в отношении поставленных задач. Идейные соображения высшего порядка."
                          img={n2}
                />
                <NewsItem title="Увлекающая история нашего бренда" day="22.12.2020"
                          post="Значимость этих проблем настолько очевидна, что сложившаяся структура организации представляет
                           собой интересный эксперимент проверки позиций, занимаемых участниками в отношении поставленных задач.
                          Равным образом укрепление и развитие структуры позволяет выполнять важные задания по разработке новых предложений."
                          img={n3}
                />
            </div>
        </div>
    )
}

export default News;